import { isEmpty } from 'lodash';
import ageRangeConverters from "../../../utils/Ages/ageRangeConverters";
import { SERVICE_AREA_TYPES, STATIC_FILTER_OPTIONS } from "./constants";
import selectHours from "./selectHours";
const {
  US_STATES
} = STATIC_FILTER_OPTIONS;
const {
  convertApiAgeRangeToUnits,
  processAgeText
} = ageRangeConverters;
const parseAge = _ref => {
  let {
    min_months,
    max_months
  } = _ref;
  if (!min_months && !max_months) return '';
  return processAgeText(...convertApiAgeRangeToUnits(`${min_months}...${max_months}`));
};
function getProgramProps(_ref2) {
  let {
    name,
    description,
    eligibility_text,
    population_restrictions = [],
    accessibility_options = [],
    delivery_options = [],
    payment_options = [],
    population_specializations = [],
    languages = [],
    services = [],
    transportation_options = [],
    city_requirements = [],
    county_requirements = [],
    postal_code_requirements = [],
    state_requirements = [],
    age_specializations = {},
    gender_requirements = [],
    age_requirements = {},
    phone_numbers = [],
    email_addresses = [],
    website_url,
    locations = [],
    receiving_referrals,
    provider,
    offers_specialized_screening,
    fee_schedule_screenings,
    fee_schedule_program,
    suggest_edit_enabled
  } = _ref2;
  const hasRequirements = !!age_requirements?.min_months || !!age_requirements?.max_months || !!city_requirements.length || !!county_requirements.length || !!gender_requirements.length || !!population_restrictions.length || !!postal_code_requirements.length || !!state_requirements.length;
  const hasAccessibility = !!delivery_options.length || !!languages.length || !!population_specializations.length || !!age_specializations?.min_months || !!age_specializations?.max_months || !!accessibility_options.length || !!transportation_options.length || !!payment_options.length;
  const hasOtherEligibility = !!eligibility_text;
  const hasEligibility = hasRequirements || hasAccessibility || hasOtherEligibility;
  const hasContactInfo = !!phone_numbers.length || !!email_addresses.length || !!website_url || !!locations.length;
  const hours = selectHours(locations, provider.hours);
  return {
    name,
    description,
    eligibility_text,
    hasRequirements,
    hasAccessibility,
    hasOtherEligibility,
    hasEligibility,
    hasContactInfo,
    postal_code_requirements: postal_code_requirements.join(', '),
    city_requirements: city_requirements.join('; '),
    county_requirements: county_requirements.join('; '),
    state_requirements: state_requirements.join(', '),
    age_requirements: parseAge(age_requirements),
    age_specializations: parseAge(age_specializations),
    gender_requirements: gender_requirements.join(', '),
    delivery_options: delivery_options.join(', '),
    population_restrictions: population_restrictions.join(', '),
    languages: languages.join(', '),
    population_specializations: population_specializations.join(', '),
    accessibility_options: accessibility_options.join(', '),
    residency: {
      state_requirements: state_requirements.join(', '),
      city_requirements: city_requirements.join('; '),
      county_requirements: county_requirements.join('; '),
      postal_code_requirements: postal_code_requirements.join(', ')
    },
    hasEligibilityText: !isEmpty(eligibility_text),
    transportation_options: transportation_options.join(', '),
    payment_options: payment_options.join(', '),
    services,
    phone_numbers,
    email_addresses: email_addresses.sort((_a, _b) => _b.is_primary === null ? -1 : 1),
    website_url,
    locations,
    hours,
    receiving_referrals,
    offersSpecializedScreening: offers_specialized_screening,
    feeScheduleScreenings: fee_schedule_screenings,
    fee_schedule_program,
    suggest_edit_enabled
  };
}
function favorPrimaryEmail(emailA, emailB) {
  if (emailB.is_primary) {
    return 1;
  }
  if (emailA.is_primary) {
    return -1;
  }
  return 0;
}
function getProviderProps(_ref3) {
  let {
    name,
    description,
    phone_numbers,
    email_addresses,
    website_url,
    hours,
    licensed,
    locations,
    id,
    sensitive
  } = _ref3;
  const emailsSortedByPriority = email_addresses.length > 0 ? email_addresses.sort(favorPrimaryEmail).map(addr => addr.email_address) : [];
  return {
    provider_id: id,
    provider_name: name,
    provider_description: description,
    provider_phone_numbers: phone_numbers,
    provider_email_addresses: emailsSortedByPriority,
    provider_website_url: website_url,
    provider_hours: hours,
    provider_licensed: licensed,
    provider_locations: locations,
    provider_sensitive: sensitive,
    hasOrgInfo: !isEmpty(description) || !isEmpty(phone_numbers) || !isEmpty(email_addresses) || !isEmpty(website_url) || !isEmpty(hours) || !isEmpty(locations)
  };
}
function generateServesThisAreaOption(area) {
  if (area.service_area_type === SERVICE_AREA_TYPES.NATIONAL) {
    return SERVICE_AREA_TYPES.NATIONAL;
  }
  return US_STATES.find(state => state.value === area.state_abbreviation.toUpperCase()).display_name;
}
function getMapProps(_ref4) {
  let {
    locations,
    service_areas
  } = _ref4;
  const closestOrFirstLocation = locations.find(loc => loc.is_closest) ?? locations[0];
  let servingArea = '';
  if (service_areas.length > 0) {
    const area = service_areas.find(a => a.service_area_type !== SERVICE_AREA_TYPES.NATIONAL) ?? service_areas[0];
    servingArea = generateServesThisAreaOption(area);
  }
  const {
    latitude,
    longitude
  } = closestOrFirstLocation ?? {};
  return {
    latitude,
    longitude,
    zoom: '15',
    servingArea,
    hasMap: !!latitude && !!longitude
  };
}
export default function formatForProgramDetail(program) {
  const programProps = getProgramProps(program);
  const providerProps = getProviderProps(program.provider);
  const mapProps = getMapProps(program);
  return {
    id: program.id,
    ...programProps,
    ...providerProps,
    ...mapProps
  };
}
//# sourceMappingURL=formatDataForProgramDetail.js.map